export default __webpack_public_path__ + "static/media/jiantou.45b8dfeb.png";